import { Button, Col, Row } from "antd";
import { useState } from "react";
import Icon from '../../../../assets/icons/icon';
import { renderErrorMessage } from "../../../../components/messages/errorMessage";
import { openFileLink } from "../../../../services/mediaService";
import { ReceivableActionPayload } from "../../../../types/entityRecordingTypes";
import format from "../../../../utilities/formatNumbers";
import { DetailsButton } from "../components/detailsButton";
import { TimelineItemProps } from "./timelineItems";

type OfferId = ReceivableActionPayload['offerId'] | undefined
export default function Receivable({ event }: TimelineItemProps<"receivable_offer_published" | "receivable_offer_sent" | "receivable_offer_accepted" | "receivable_invoice_created" | "receivable_invoice_sent" | "receivable_invoice_paid">) {
  const [downloading, setDownloading] = useState(false)
  const [regeneratingOffer, setRegeneratingOffer] = useState(false)
  const [showDetails, setShowDetails] = useState(false)

  async function download() {
    try {
      setDownloading(true)
      if ((event.payload?.links.offerPdf && event.eventType === 'receivable_offer_published') || (event.eventType === 'receivable_offer_accepted' || event.eventType === 'receivable_offer_sent')) {
        await openFileLink(event.payload?.links.offerPdf)
      } else if (event.payload?.links.invoicePdf && event.eventType === 'receivable_invoice_created' || event.eventType === 'receivable_invoice_sent' || event.eventType === 'receivable_invoice_paid') {
        await openFileLink(event.payload?.links.invoicePdf)
      }
    } catch (error) {
      renderErrorMessage(error)
    } finally {
      setDownloading(false)
    }
  }
  // TODO: Implement these endpoints
  async function regenerateOffer(id: OfferId) {
    try {
      setRegeneratingOffer(true)
      await new Promise(r => setTimeout(r, 500))
    } catch (error) {
      renderErrorMessage(error)
    } finally {
      setRegeneratingOffer(false)
    }
  }
  return (
    <div>
      <div className="mb-05">
        <Row justify="space-between" align="middle">
          <Col>{event.displayText}</Col>
          <Col>
            <DetailsButton showDetails={showDetails} onClick={() => setShowDetails(!showDetails)} />
          </Col>
        </Row>
      </div>
      {showDetails && (
        <div className="p-05 mt-05 border-light border-radius bg-light">
          <Row justify="space-between" align="middle">
            <Col style={{ display: "flex", alignItems: "center" }}>
              <Icon name="attach-outline" size="large" className="text-primary" />
              <div>
                <Button style={{ display: "block", fontWeight: 400 }}
                  type="link" size="small"
                  onClick={() => download()}
                  disabled={downloading}
                >
                  {event.payload?.title}
                </Button>
                <small style={{ marginTop: -4, display: 'block', marginLeft: 8 }}>
                  {event.payload?.paymentTerms}{' - '}
                  {format.price(event.payload?.totalWithVat)}
                </small>
              </div>
            </Col>
            <Col>
              <Button
                type="link"
                onClick={() => download()}
                loading={downloading}
                icon={<Icon name="download-outline" />}
              />
              {/* {true && ( */}
              {/*   <Button */}
              {/*     type="link" */}
              {/*     onClick={() => regenerateOffer(event.payload?.offerId)} */}
              {/*     loading={regeneratingOffer} */}
              {/*     icon={<Icon name="arrows-clockwise" />} */}
              {/*   /> */}
              {/* )} */}
            </Col>
          </Row>
        </div>
      )}

    </div>
  )
}
